import React from "react";
import Video from "../assets/globe.mp4";
import languageStorage from "../lang/findLanguage";

export default function Header({ language }) {
  console.log("...");
  return (
    <header className="header">
      <div className="container">
        <div className="banner d-flex align-items-center flex-column">
          <h1>{languageStorage() === "tr" ? language[0].sections[1].keys[0].k0001 : language[1].sections[1].keys[0].k0001}</h1>
          <p>{languageStorage() === "tr" ? language[0].sections[1].keys[1].k0002 : language[1].sections[1].keys[1].k0002}</p>
          <button
            onClick={() =>
              (window.location.href = `#${languageStorage() === "tr" ? language[0].sections[11].keys[5].k0006 : language[1].sections[11].keys[5].k0006}`)
            }
          >
            {languageStorage() === "tr" ? language[0].sections[1].keys[2].k0003 : language[1].sections[1].keys[2].k0003}
          </button>
          <div className="video">
            <video autoPlay playsInline muted loop>
              <source src={Video} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </header>
  );
}
